// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Vvfb","left":"styles_left__3JMW6"};